import React from 'react';
import PropTypes from 'prop-types';
//import { getPosition } from 'utils/DOMUtils';

class Tooltip extends React.Component {
  static propTypes = {
    data: PropTypes.shape({}).isRequired,
    styles: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    if (this.myRef && !this.unmounted) {
      const { myRef } = this;
      const elem = myRef.getBoundingClientRect();
      const yPosition = elem.top - this.props.offSetFromTop;
      //const yPosition = getPosition(myRef).y;
      if (yPosition > myRef.offsetHeight) {
        this.setState({ showAbove: true });
      } else {
        // this.setState({ showBelow: true });
      }
    }
  }
  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    let reqClass = '';
    const s = this.props.styles;
    if (this.state.showAbove) {
      reqClass = s.tooltip_up;
    } else {
      reqClass = 'tooltip_down';
    }
    return (
      <div
        className={`${s.point_tooltip} ${reqClass}`}
        ref={myRef => {
          this.myRef = myRef;
        }}
      >
        {this.props.data}
      </div>
    );
  }
}

Tooltip.propTypes = {
  offSetFromTop: PropTypes.number,
};
Tooltip.defaultProps = {
  offSetFromTop: 0,
};
export default Tooltip;
